import React from "react";

import { Typography, TypographyProps } from "@mui/material";

export const SectionTitle = ({
  children,
  sx,
  ...otherProps
}: TypographyProps) => {
  return (
    <Typography
      variant="h3"
      fontWeight={400}
      fontSize={20}
      lineHeight={1.5}
      sx={{ ...sx }}
      {...otherProps}>
      {children}
    </Typography>
  );
};
